import { memo, useEffect, useRef } from 'react';
import { connect } from 'react-redux';
import { fetchCropHealth } from 'js/reducers/FieldReducer';

const mapStateToProps = (store) => {
  return {
    farm: store.farm.farm,
    dates: store.field.dates,
    date: store.field.date?.date,
    fields: store.field.fields,
    fieldsLoaded: store.field.fieldsLoaded,
    images: store.field.images,
    syncing: store.sync.syncing,
    loggedIn: store.credential.loggedIn,
    selectedSeason: store.season.selectedSeason,
  };
};

const CrophealthLoaderContainer = ({
  dispatch,
  dates,
  fields,
  farm,
  date,
  images,
  syncing,
  loggedIn,
  fieldsLoaded,
  selectedSeason,
}) => {
  const currentDates = useRef(dates);
  const farmId = farm.farmId;
  const currentSeason = useRef(selectedSeason);

  useEffect(() => {
    if (dates && fields && loggedIn && !syncing && fieldsLoaded) {
      const datesChanged = currentDates.current !== dates;
      const dateNotLoaded = !images.get(date);
      const seasonChanged = currentSeason.current?.id !== selectedSeason?.id;

      if ((datesChanged && dateNotLoaded) || dateNotLoaded || seasonChanged) {
        dispatch(fetchCropHealth(farmId, date, fields));
        currentDates.current = dates;
        currentSeason.current = selectedSeason;
      }
    }
  }, [currentDates.current, dates, date, fields, farmId, images, syncing, loggedIn, fieldsLoaded]);

  return null;
};

export default memo(connect(mapStateToProps)(CrophealthLoaderContainer));
